import {View, Component} from 'angular2/core';
import {Location, RouteConfig, RouterLink, Router} from 'angular2/router';

import {LoggedInRouterOutlet} from './LoggedInOutlet';
import {Login} from '../user/login/login';
import {Logout} from '../user/logout/logout';
import {Signup} from '../user/signup/signup';
import {EventList} from '../event/event-list';
import {EventDetail} from '../event/event-detail';
import {EventView} from '../event/event-view';
import {CompanyList} from '../company/company-list';
import {CompanyDetail} from '../company/company-detail';
import {AttendeeRegister} from '../attendee/attendee-register';
import {Main} from '../layout/main/main';

let template = require('./app.html');

@Component({
  selector: 'afeb-app'
})
@View({
  template: template,
  directives: [ LoggedInRouterOutlet ]
})
@RouteConfig([
  { path: '/main', component: Main, as: 'Main' },
  { path: '/admin/users/login', component: Login, as: 'Login' },
  { path: '/admin/users/logout', component: Logout, as: 'Logout' },
  { path: '/admin/users/signup', component: Signup, as: 'Signup' },

  { path: '/admin/events/new', component: EventDetail, as: 'EventNew' },
  { path: '/admin/events/detail/:id', component: EventDetail, as: 'EventDetail' },
  { path: '/admin/events/view/:id', component: EventView, as: 'EventView' },
  { path: '/admin/events/list', component: EventList, as: 'EventList'},

  { path: '/admin/companies/new', component: CompanyDetail, as: 'CompanyNew' },
  { path: '/admin/companies/detail/:id', component: CompanyDetail, as: 'CompanyDetail' },
  { path: '/admin/companies/list', component: CompanyList, as: 'CompanyList'},

  { path: '/attendees/register', component: AttendeeRegister,
    as: 'AttendeeRegister', useAsDefault: true},
])
export class App {
  constructor(public router: Router) {
  }
}



/** WEBPACK FOOTER **
 ** ./~/tslint-loader!./src/app/app.ts
 **/